import { defineAction } from '~/prix'
import { z } from 'zod'
import creditRequestUpdateAction from './creditRequestUpdate.action.json' with { type: 'json' }
import { creditRequestUpdateInputObject } from '../creditRequestObject'

const creditRequestUpdateDefinition = defineAction({
  ...creditRequestUpdateAction,

  input: creditRequestUpdateInputObject,
  output: z.object({}),
})

export default creditRequestUpdateDefinition

